import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHelmet = () => {
  return (
    <Helmet>
      {/* Structured data for rich results */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org/",
            "@type": "Person",
            "name": "Nidal Raed",
            "url": "https://nidalraed.com/",
            "image": "https://nidalraed.com/profile-image.jpg",
            "jobTitle": "Full-Stack Developer",
            "worksFor": {
              "@type": "Organization",
              "name": "Freelance"
            },
            "sameAs": [
              "https://github.com/nidalraed",
              "https://linkedin.com/in/nidalraed",
              "https://twitter.com/nidalraed"
            ],
            "description": "Full-Stack Developer specializing in React, Node.js, and modern web technologies."
          }
        `}
      </script>
      
      {/* Additional meta tags that can be dynamically changed */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="revisit-after" content="7 days" />
      <meta name="language" content="English" />
    </Helmet>
  );
};

export default SEOHelmet;
